import React, { Component } from 'react';
import * as GlobalActions from '../../../reducers/actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import LandingStyles from '../LandingStyles';
import LandingImages from '../LandingImages';
import { S3HOST } from '../../../ApiConstants';
import WhyJoinCard from '../LandingSubComponents/WhyJoinCard';
import Fade from 'react-reveal/Fade';
import view from '../../../Enums';

class WhyJoinOyo extends Component {

  render() {
    let gc = this.props.gc;
    let guc = this.props.guc;
    let gs = this.props.gs;
    let gi = this.props.gi;

    let marginLeft = Math.max((window.innerWidth - 1200) / 2, 10);

    return (
      <div
        ref={this.props.setWhyOyo2Ref}
        style={{ margin: this.props.viewMode == view.DESKTOP ? '80px 0px' : '40px 0px' }}
      >
        <Fade bottom>
          <div style={gs('why_oyo_head')}>
            <div style={gs('bold_big_head')}>{gc('why_oyo')}</div>
            <div style={gs('bold_big_sub_head')}>
              {gc('why_join_oyo_sub_heading')}
            </div>
          </div>

          {/*images*/}
          <div
            style={{
              ...gs('images_div_why_join'),
              paddingBottom: '35px'
              // marginLeft: marginLeft,
              // marginRight: marginLeft
              // maxWidth: '1200px'
            }}
          >
            <div
              style={{ ...gs('images_sub_div_why_join'), paddingLeft: '10px' }}
            >
              <WhyJoinCard
                hideWhyOyo={this.props.hideWhyOyo}
                eventAction={'Learned more - Channel Management'}
                viewMode={this.props.viewMode}
                subContent={gc('landing_modal_content1')}
                img={gi('channel')}
                heading={gc('channel_management')}
                content={gc('channel_management_content')}
                learnMore={guc('footer_c3_l2')}
                link={this.props.link}
              />
            </div>

            <div style={gs('images_sub_div_why_join')}>
              <WhyJoinCard
                eventAction={'Learned more - Revenue Management'}
                hideWhyOyo={this.props.hideWhyOyo}
                viewMode={this.props.viewMode}
                subContent={gc('landing_modal_content2')}
                img={gi('revenue_management')}
                heading={gc('revenue_management')}
                content={gc('revenue_management_content')}
                learnMore={guc('footer_c3_l2')}
                link={this.props.link}
              />
            </div>

            <div style={gs('images_sub_div_why_join')}>
              <WhyJoinCard
                hideWhyOyo={this.props.hideWhyOyo}
                eventAction={'Learned more - Technology'}
                viewMode={this.props.viewMode}
                subContent={gc('landing_modal_content3')}
                img={gi('technology')}
                heading={gc('technology')}
                content={gc('technology_content')}
                learnMore={guc('footer_c3_l2')}
                link={this.props.link}
              />
            </div>

            <div style={gs('images_sub_div_why_join')}>
              <WhyJoinCard
                eventAction={'Learned more - Guest Experience'}
                hideWhyOyo={this.props.hideWhyOyo}
                viewMode={this.props.viewMode}
                subContent={gc('landing_modal_content4')}
                img={gi('guest_experience')}
                heading={gc('guest_experience')}
                content={gc('guest_experience_content')}
                learnMore={guc('footer_c3_l2')}
                link={this.props.link}
              />
            </div>
          </div>
        </Fade>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    globalActions: bindActionCreators(GlobalActions, dispatch)
  };
};

const mapStateToProps = state => {
  return {
    globalData: state.globalReducer
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WhyJoinOyo);
